import React, {
  useCallback,
  useMemo,
  useRef,
  useEffect,
  useState,
} from "react";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  Text,
  FloatingButton,
  FlexRowFluid,
  SwipeTabs,
  SwipeTab,
} from "../../styles/Global";
import * as Global from "../../styles/Global";
import { FaLock } from "react-icons/fa";
import { useTheme } from "@mui/material/styles";
import { AiFillSetting } from "react-icons/ai";
import SwipeableViews from "react-swipeable-views-react-18-fix";
import Box from "@mui/material/Box";
import "../../App.scss";
import "animate.css";
import { connect, useSelector } from "react-redux";
import UpgradeBlurComponent from "../../components/UpgradeBlurComponent";
import {
  usePlayerPPRMutation,
  usePlayerSPRMutation,
  usePlayerRankMutation,
} from "../../services/playerApi";
import moment from "moment";
import { times } from "lodash";
import BagsRadarPlot from "./BagsRadarPlot";
import SPRChart from "./SPRChart";
import PPRChart from "./PPRChart";
import PPRColumnChart from "./PPRColumnChart";
import RankChart from "./RankChart";
import AreaChart from "@ant-design/plots/es/components/area";
import GameHistoryChart from "./GameHistoryChart";
import MatchHistory from "./MatchHistory";
import SkeletonLoader from "../../components/SkeletonLoader";

const mapDispatch = {};

const SwipeCharts = ({
  blur,
  data,
  userID,
  sport,
  type,
  isOrganizer,
  paidTier,
  setChartValue,
  isLoading,
  isProSub,
}) => {
  // console.log("swipeCharts data: ", data);
  const navType = new URL(window.location.href).pathname.split("/")[3];
  console.log("SwipeCharts navType: ", navType);
  const player = useSelector((state) => state.player);
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }
  const theme = useTheme();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    //console.log("tabPanel value: ", value);

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && children}
      </div>
    );
  }

  function FormatTimestamps(item) {
    //console.log("format time stamp item: ", item);
    const newArr = item.map((obj) => {
      let newObj = {
        ...obj,
      };
      newObj.timestamp = moment(obj.timestamp).format("MMM DD YYYY");
      return newObj;
    });
    return newArr;
  }

  const requestBody = {
    userid: userID,
    sport: sport,
    timezone: tz,
  };
  let tabTypes = [];
  let tabComponents = [];
  switch (type) {
    case "mainProfile":
      if (player.profileData.hasPpr) {
        tabTypes =
          sport === "axethrowing"
            ? ["spr", "ppr points", "ppr", 
              // "rank"
            ]
            : [
                "spr",
                "ppr points",
                "ppr",
                `${sport === "horseshoes" ? "shoes" : "bags"}`,
                // "rank",
              ];
        tabComponents = [
          <SPRChart
            FormatTimestamps={FormatTimestamps}
            userID={userID}
            sport={sport}
            requestBody={requestBody}
          />,
          <PPRColumnChart
            FormatTimestamps={FormatTimestamps}
            userID={userID}
            sport={sport}
            requestBody={requestBody}
          />,
          <PPRChart
            FormatTimestamps={FormatTimestamps}
            userID={userID}
            sport={sport}
            requestBody={requestBody}
          />,
          <BagsRadarPlot data={data} />,
          // <RankChart
          //   FormatTimestamps={FormatTimestamps}
          //   userID={userID}
          //   sport={sport}
          //   requestBody={requestBody}
          // />,
        ];
      } else {
        tabTypes =
          sport === "pickleball"
            ? ["DUPR Doubles", "DUPR Singles"]
            : ["spr", 
              // "rank"
            ];
        tabComponents =
          sport === "pickleball"
            ? [
                <SPRChart
                  FormatTimestamps={FormatTimestamps}
                  userID={userID}
                  sport={sport}
                  requestBody={requestBody}
                  type="duprDoubles"
                />,
                <SPRChart
                  FormatTimestamps={FormatTimestamps}
                  userID={userID}
                  sport={sport}
                  requestBody={requestBody}
                  type="duprSingles"
                />,
              ]
            : [
                <SPRChart
                  FormatTimestamps={FormatTimestamps}
                  userID={userID}
                  sport={sport}
                  requestBody={requestBody}
                />,
                // <RankChart
                //   FormatTimestamps={FormatTimestamps}
                //   userID={userID}
                //   sport={sport}
                //   requestBody={requestBody}
                // />,
              ];
      }
      break;
    case "organizerStats":
      tabTypes = ["Tournaments", "Players", "Matches"];
      tabComponents = [
        <GameHistoryChart data={data ? data.gameHistoryCount : []} />,
        <GameHistoryChart data={data ? data.gameHistoryPlayers : []} />,
        <MatchHistory data={data ? data.matchHistory : []} />,
      ];
      break;
    default:
      break;
  }

  useEffect(() => {
    if (type === "organizerStats") {
      // get new tab data
      if (isProSub) {
        //  getStats({
        //    sport: sport,
        //    // startdate: SetDateFormat(startDate),
        //    // enddate: SetDateFormat(endDate),
        //    startdate: startDate,
        //    enddate: endDate,
        //    timezone: tz,
        //    format: format,
        //    generation: generation,
        //  });
      }
    }
  }, [value]);

  return (
    <ContentSection
      style={{
        flex: 0,
        margin: "0 20px 20px",
      }}
      className={!isOrganizer && "animate__animated animate__bounceInLeft"}
    >
      <Text size="12px" style={{ textAlign: "center" }}>
        CHARTS!
      </Text>
      <UpgradeBlurComponent
        isVisible={blur}
        blurStyle={{ left: 0, top: 0, right: 0, bottom: 0 }}
        isOrganizer={navType !== "player"}
        paidTier={paidTier}
        buttonText={navType === "player" ? "Upgrade to SPR+" : "Upgrade to PRO"}
        children={
          isLoading ? (
            <SkeletonLoader />
          ) : (
            <>
              <FlexColumn align="stretch" style={{ flex: 1 }}>
                <SwipeTabs
                  value={value}
                  onChange={handleChange}
                  // indicatorColor="secondary"
                  textColor="inherit"
                  aria-label="advanced stats tabs"
                  marginTop="0"
                  variant="scrollable"
                  scrollButtons="auto"
                  width={
                    type === "organizerStats"
                      ? "33.33%"
                      : player.profileData.hasPpr
                      ? "25%"
                      : "50%"
                  }
                >
                  {tabTypes.map((tab, index) => {
                    return (
                      <SwipeTab
                        key={index.toString()}
                        label={tab}
                        {...a11yProps(index)}
                        style={{
                          minWidth:
                            type === "organizerStats"
                              ? "33.3333%"
                              : player.profileData.hasPpr
                              ? "25%"
                              : "50%",
                        }}
                      />
                    );
                  })}
                </SwipeTabs>
                {/* <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={value}
                onChangeIndex={handleChangeIndex}
              > */}
                {tabComponents.map((component, index) => {
                  return (
                    <TabPanel
                      key={index.toString()}
                      value={value}
                      index={index}
                    >
                      {component}
                    </TabPanel>
                  );
                })}
                {/* </SwipeableViews> */}
              </FlexColumn>
            </>
          )
        }
      />
    </ContentSection>
  );
};

export default connect(null, mapDispatch)(SwipeCharts);
